import enviro from 'enviro';
import { logRavenException } from '../../_core/utils/errors';
export const validateNumber = (value, upgradeKey, paramName) => {
  if (Number.isInteger(value)) {
    return value;
  }
  const errorMessage = `UIUsageLimitCounter: Invalid value passed into ${paramName} for upgradeKey ${upgradeKey}. Value ${value} should be an integer.`;
  logRavenException({
    customMessage: errorMessage,
    error: Error('validation error in validateNumber')
  });
  if (enviro.isQa()) {
    console.warn(errorMessage);
  }
  return 0;
};